export default {"src":"/_next/static/media/app-google-play-black.23948f62.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};